document.addEventListener("turbolinks:load", function () {
  setupSlick($('.js-scenes').not('.slick-initialized'));
});

document.addEventListener("turbolinks:before-cache", function () {
  $('.js-scenes.slick-initialized').slick('unslick');
});

document.addEventListener("turbolinks:render", function () {
  setupSlick($('.js-scenes'));
});

function setupSlick(elem) {
  elem.slick({
    autoplay: false,
    infinite: false,
    speed: 300,
    variableWidth: true,
    dots: true,
    swipeToSlide: true,
    slidesToShow: 3,
    responsive: [{
      breakpoint: 580,
      settings: {
        slidesToShow: 2
      }
    }]
  });
}
